import PreviewQuestionnaire from 'app/features/questionnaires/show/PreviewQuestionnaire';
import React, { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { suspense } from './utils';

const ShowQuestionnaire = lazy(
  () => import('app/features/questionnaires/show'),
);

const ViewProjects = lazy(
  () => import('admin/features/projectsManagment/viewProjects'),
);
const ProjectDetails = lazy(
  () => import('admin/features/projectsManagment/viewProjects/ProjectDetails'),
);
const ProjectDocuments = lazy(
  () =>
    import('admin/features/projectsManagment/viewProjects/ProjectDocuments'),
);
const ProjectNotes = lazy(
  () => import('admin/features/projectsManagment/viewProjects/ProjectNotes'),
);

export default function ProjectDetailsRoutes() {
  return (
    <>
      <Route
        path="taxReturns/:taxReturnId"
        element={suspense(<ViewProjects />)}
      >
        <Route path="details" element={suspense(<ProjectDetails />)} />
        <Route path="documents" element={suspense(<ProjectDocuments />)} />
        <Route path="notes" element={suspense(<ProjectNotes />)} />
        {/* <Route path="questionnaire" element={suspense(<ShowQuestionnaire />)} /> */}
        <Route path="" element={<Navigate replace to="details" />} />
      </Route>
      <Route
        path="taxReturns/:questionnaireId/questionnaire"
        element={suspense(<ShowQuestionnaire />)}
      />
    </>
  );
}
